import { render } from "./TotalDebitCol.vue?vue&type=template&id=4b3f836e"
import script from "./TotalDebitCol.vue?vue&type=script&lang=js"
export * from "./TotalDebitCol.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__